import React from 'react';
import { Icon, InputText } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import PropTypes from 'prop-types';
import { FORM_KEYS } from '../../../../../constants/formKeys';
import { VALIDATION_ERROR_MESSAGE } from '../../../../../constants/errorMessage';
import ErrorText from '../../../../shared/ErrorText/ErrorText';

const NewPasswordField = ({
  fieldFormContext,
  showPassword,
  newPasswordOnChange,
  errors,
  togglePasswordVisibility
}) => {
  return (
    <div className="passwordFieldContainer">
      <div className="newPasswordInputContainer">
        <InputText
          {...{
            fieldFormContext,
            label: 'New password',
            name: FORM_KEYS.NEW_PASSWORD,
            inputType: showPassword.new ? 'text' : 'password',
            placeholder: 'Enter new password',
            defaultValue: '',
            validation: {
              required: 'Please enter a new password.'
            },
            customChangeHandler: newPasswordOnChange,
            customCssClass:
              errors.isPasswordLengthErrorMessageDisplayed ||
              errors.isPasswordUppercaseErrorMessageDisplayed ||
              errors.isPasswordDigitErrorMessageDisplayed ||
              errors.isInvalidNewPassword
                ? 'newPasswordField error'
                : 'newPasswordField',
            customPostInputContent: (
              <Icon
                icon={showPassword.new ? 'password-visible' : 'password-hidden'}
                onClick={() => togglePasswordVisibility('new')}
                customCssClass="toggle-password-icon"
              />
            )
          }}
        />
      </div>
      <div className="custom_validation_list">
        <ErrorText
          cssClass="custom_validation"
          message={[
            {
              value: VALIDATION_ERROR_MESSAGE.PASSWORD_MUST_BE_MIN_8_CHARACTERS,
              isDisplayed: errors.isPasswordLengthErrorMessageDisplayed
            },
            {
              value: VALIDATION_ERROR_MESSAGE.PASSWORD_MUST_CONTAIN_UPPERCASE,
              isDisplayed: errors.isPasswordUppercaseErrorMessageDisplayed
            },
            {
              value: VALIDATION_ERROR_MESSAGE.PASSWORD_MUST_CONTAIN_DIGIT,
              isDisplayed: errors.isPasswordDigitErrorMessageDisplayed
            },
            {
              value: VALIDATION_ERROR_MESSAGE.PASSWORD_MUST_NOT_CONTAIN_PASSWORD,
              isDisplayed: errors.isPasswordNotPasswordErrorMessageDisplayed
            }
          ]}
        />
        <ErrorText
          cssClass="custom_validation"
          message={[{ value: VALIDATION_ERROR_MESSAGE.NEW_PASSWORD_NOT_OLD, isDisplayed: errors.isInvalidNewPassword }]}
        />
      </div>
    </div>
  );
};

export default NewPasswordField;

NewPasswordField.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fieldFormContext: PropTypes.any.isRequired,
  showPassword: PropTypes.shape({
    new: PropTypes.bool.isRequired
  }).isRequired,
  newPasswordOnChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    isPasswordLengthErrorMessageDisplayed: PropTypes.bool.isRequired,
    isPasswordUppercaseErrorMessageDisplayed: PropTypes.bool.isRequired,
    isPasswordDigitErrorMessageDisplayed: PropTypes.bool.isRequired,
    isPasswordNotPasswordErrorMessageDisplayed: PropTypes.bool.isRequired,
    isInvalidNewPassword: PropTypes.bool.isRequired
  }).isRequired,
  togglePasswordVisibility: PropTypes.func.isRequired
};
